import * as React from 'react';
import {readUserAgent, userAgent} from '../../functions/analyseUserAgent';
import './Footer.css';
 
class Footer extends React.Component {
  public render() {
    readUserAgent();
    if (userAgent.isApp !== true) {
      return (
        <footer className="footer">
          {/* <div className="footerContent"> */}
            <p className="footerContent"> Made with ♥ by Digital Excellence </p>            
          <p className="footerContent2">Otto Group Holding・Werner-Otto-Straße 1-7・22179 Hamburg </p>
          {/* </div> */}
        </footer>
      );
    } else {
      return null;
    }
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.tsx